/*
 * Dev-host detection. The ProjectsPage (internal project picker) and the
 * not-yet-public sites (e.g. ABC DK under /abc-webshop/dk) render only here.
 *
 * Besides localhost and the internal preview host, private-network addresses
 * count as dev: they are how the local dev server is opened from a phone or
 * another computer on the same Wi-Fi (http://192.168.x.x:3001,
 * http://<mac-name>.local:3001). Production is never served from these.
 */
const DEV_HOSTS = ['localhost', '127.0.0.1', '[::1]', 'fe1487.clseifert.com'];

// RFC 1918 private IPv4 ranges: 10/8, 172.16/12, 192.168/16
const PRIVATE_IPV4 =
  /^(10\.\d{1,3}\.\d{1,3}\.\d{1,3}|192\.168\.\d{1,3}\.\d{1,3}|172\.(1[6-9]|2\d|3[01])\.\d{1,3}\.\d{1,3})$/;

export function isDevHostname(hostname) {
  const host = String(hostname || '').toLowerCase();
  if (!host) return false;
  return DEV_HOSTS.includes(host) || PRIVATE_IPV4.test(host) || host.endsWith('.local');
}

// The local dev server counts on ANY hostname (a production build is never in
// development mode), so e.g. a LAN name not matched above still works.
export const isDevHost = process.env.NODE_ENV === 'development'
  || (typeof window !== 'undefined' && isDevHostname(window.location.hostname));
